var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page row"},[_c('div',{staticClass:"span8 page-content"},[_c('help-widget'),_c('oldstuff-widget'),_c('news-widget')],1),_c('div',{staticClass:"span4 page-sidebar"},[_c('carousel-widget'),_c('activity-widget'),_c('job-widget')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }